"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _utils = require("../utils/utils");

var _default = {
  title: 'Layout Direction',
  isRelevant: function isRelevant() {
    return true;
  },
  type: _constants.INPUT_TYPES.OPTIONS,
  "default": _constants.GALLERY_CONSTS.layoutDirection.LEFT_TO_RIGHT,
  options: (0, _utils.createOptions)('layoutDirection'),
  description: "Set the direction of the gallery layout (right to left or left to right)"
};
exports["default"] = _default;